var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{ref:"empty",staticClass:"custom-image",attrs:{"image":_vm.ImgEmpty,"description":_vm.noData}})}
var staticRenderFns = []

export { render, staticRenderFns }